<vue-page-header
  [pageTitle]="'label.passwordReset.changePassword' | translate | async"
  [previousPageTitle]="
    isQuestionSelected ? ('label.forgotPassword' | translate | async) : null
  "
  (previousPageButtonClicked)="forgotPassword()"
>
</vue-page-header>
<vue-panel [title]="'label.enterNewPasswordLabel' | translate | async">
      <vue-server-messages [messages]="messages"></vue-server-messages>
      <div *ngIf="verified">
        <vue-password-strength-input
          [newPasswordLabel]="'passwordTab.newPassword' | translate | async"
          [confirmPasswordLabel]="
            'passwordTab.reEnterNewPassword' | translate | async
          "
          [validationRequiredRules]="requiredRules"
          #passwordInputContainer
          [hasOldPassword]="false"
          [formError]="formError"
          inputWidthClass="wider"
          [autofocus]="true"
        >
        </vue-password-strength-input>
        <vue-form-buttons
          [defaultLabel]="'label.cancel' | translate | async"
          (defaultButtonClicked)="forgotPassword()"
          [defaultVisible]="isQuestionSelected"
          defaultPosition="btn-left"
          [primaryLabel]="'label.submit' | translate | async"
          (primaryButtonClicked)="changePassword()"
        >
        </vue-form-buttons>
      </div>
</vue-panel>
